/*
 * @Author: your name
 * @Date: 2020-09-09 16:02:18
 * @LastEditTime: 2020-11-13 14:05:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lzxy-homepage\src\utils\tool.ts
 */
export const getUrlFileName = (): string => {
  const urlName = window.location.href
  const urlFileName = urlName.split('/')[3]
  return urlFileName
}

export const getUrlParam = (param: string) => {
  const reg = new RegExp('(^|&)' + param + '=([^&]*)(&|$)')
  const r = window.location.search.substr(1).match(reg)
  if (r !== null) {
    return decodeURI(r[2])
  } else {
    return ''
  }
}
export const parseTime = (
  date: number,
  format: string
): string => {
  if (date === null) {
    return ''
  }
  console.log(date)
  console.log(format)
  // if (!format) {
  //   format = 'yy-MM-dd'
  // }
  // const dateData = new Date(parseInt(date))
  // const dict: any = {
  //   yy: dateData.getFullYear(),
  //   M: dateData.getMonth() + 1,
  //   d: dateData.getDate(),
  //   H: dateData.getHours(),
  //   m: dateData.getMinutes(),
  //   s: dateData.getSeconds(),
  //   MM: ('' + (dateData.getMonth() + 101)).substr(1),
  //   dd: ('' + (dateData.getDate() + 100)).substr(1),
  //   HH: ('' + (dateData.getHours() + 100)).substr(1),
  //   mm: ('' + (dateData.getMinutes() + 100)).substr(1),
  //   ss: ('' + (dateData.getSeconds() + 100)).substr(1)
  // }
  // return format.replace(/(yy|MM?|dd?|HH?|ss?|mm?)/g, function (arg: any) {
  //   return dict[arg]
  // })
  const dateString = new Date(date).toJSON()
  const mydate = new Date(+new Date(dateString) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
  if (format === 'all') {
    return mydate
  } else {
    return mydate.split(' ')[0]
  }
}

export const parseProgress = (curNum: number, total: number): number => {
  if (total === 0 || !total) {
    return 0
  } else {
    return parseInt(Math.round(curNum / total * 10000) / 100.00 + '')
  }
}

export const formatSeconds = (value: number) => {
  const h = Math.floor(value / 3600) < 10 ? '0' + Math.floor(value / 3600) : Math.floor(value / 3600)
  const m = Math.floor((value / 60 % 60)) < 10 ? '0' + Math.floor((value / 60 % 60)) : Math.floor((value / 60 % 60))
  const s = Math.floor((value % 60)) < 10 ? '0' + Math.floor((value % 60)) : Math.floor((value % 60))
  return h + ':' + m + ':' + s
}

export const formatSecondsChinense = (value: number) => {
  const h = Math.floor(value / 3600) < 10 ? '0' + Math.floor(value / 3600) : Math.floor(value / 3600)
  const m = Math.floor((value / 60 % 60)) < 10 ? '0' + Math.floor((value / 60 % 60)) : Math.floor((value / 60 % 60))
  const s = Math.floor((value % 60)) < 10 ? '0' + Math.floor((value % 60)) : Math.floor((value % 60))
  return h + '年' + m + '月' + s + '日'
}

export const timeToSec = (time: string) => {
  let s = 0
  const hour = parseInt(time.split(':')[0])
  const min = parseInt(time.split(':')[1])
  const sec = parseInt(time.split(':')[2])
  s = Number(hour * 3600) + Number(min * 60) + Number(sec)
  return s
}

export const progressComputer = (curNum: number, total: number) => {
  if (!total || !curNum || curNum === 0 || total === 0) {
    return '0'
  }
  const reduce = ((curNum / total) * 100).toFixed(1)
  return String(reduce)
}

export const durToCourseHour = (duration: number | undefined | null | string) => {
  if (duration === undefined && duration === null) {
    return {
      courseHour: 0,
      courseDuration: 0
    }
  }
  const courseHour = Math.ceil(Number(duration) / (45 * 60))
  const courseDuration = Math.ceil(Number(duration) / 60)
  return {
    courseHour,
    courseDuration
  }
}
